<template>
	<div>
		<el-row class="crumbs-box">
			<el-row>
				<el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<el-breadcrumb-item>反馈信息</el-breadcrumb-item>
				</el-breadcrumb>
			</el-row>
			<el-row class="selectbox">
				<el-col :span="1" class="seachTitleContent">
					姓名:
				</el-col>
				<el-col :span="3" class="inputRight">
					<input class="select" v-model="searchForm.name" :maxlength="10">
				</el-col>
				<el-col :span="2" class="seachTitleContent">
					联系电话:
				</el-col>
				<el-col :span="3" class="inputRight">
					<input class="select" v-model="searchForm.phone">
				</el-col>
				<el-col :span="1" class="seachTitleContent">
					邮箱:
				</el-col>
				<el-col :span="3">
					<input class="select" v-model="searchForm.email">
				</el-col>
				<el-col :span="1" :offset="1">
					<button @click="search" class="searchbtn">查询</button>
				</el-col>
				<el-col :span="1" style="margin-left: 20px;">
					<button @click="reset" class="resetbtn">重置</button>
				</el-col>
			</el-row>
		</el-row>
		<el-row class="formbox">
			<el-row>
				<table class="tablebox" v-if="issearch==false">
					<tr class="table-firsttitle">
						<td>姓名</td>
						<td>联系电话</td>
						<td>邮箱</td>
						<td>留言时间</td>
						<td>留言信息</td>
					</tr>
					<tr class="table-trtitle" v-for="item in list">
						<td>
							<p class="tableTitle" :title="item.name">
								{{item.name}}
							</p>
						</td>
						<td>{{item.phone}}</td>
						<td>
							<p class="tableTitle" :title="item.mail">
								{{item.mail}}
							</p>
						</td>
						<td>{{item.createTime}}</td>
						<td class="tableContent">
							<el-tooltip effect="light" placement="top">
								<div slot="content" class="tooltipitem">{{ item.leaveContent }}</div>
								<p class="tableTitle">
									{{item.leaveContent}}
								</p>
							</el-tooltip>
						</td>
					</tr>
				</table>
				<!-- 搜索数据 -->
				<table class="tablebox" v-else>
					<tr class="table-firsttitle">
						<td>姓名</td>
						<td>联系电话</td>
						<td>邮箱</td>
						<td>留言时间</td>
						<td>留言信息</td>
					</tr>
					<tr class="table-trtitle">
						<td>{{searchList.name}}</td>
						<td>{{searchList.phone}}</td>
						<td>{{searchList.mail}}</td>
						<td>{{searchList.createTime}}</td>
						<td>
							<el-tooltip effect="light"  placement="top">
								<div slot="content" class="tooltipitem">{{ searchList.leaveContent }}</div>
								<p class="tableTitle">
									{{searchList.leaveContent}}
								</p>
							</el-tooltip>
						</td>
					</tr>
				</table>
				<div class="block" style="margin-top: 20px;">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page.sync="currentPage"
						:page-sizes="[10,20,30]"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total">
				    </el-pagination>
				</div>
			</el-row>
		</el-row>
	</div>
</template>

<script>
	import { leaveList } from '@/api/index.js'
	export default
	{
		data()
		{
			return{
				list:[],
				
				// 总共页数
				page:1,
				// 每页条数
				pageSize:10,
				// 当前页数
				currentPage:1,
				// 总条数
				total:0,
				
				// 搜索
				issearch:false,
				searchList:{},
				
				// 搜索列表
				searchForm:
				{
					name:'',
					phone:'',
					email:''
				},
			}
		},
		created()
		{
			this.getList();
		},
		methods:
		{
			// 获取内容数据
			getList()
			{
				console.log(this.page)
				leaveList({page:this.page,pageSize:this.pageSize,mail:this.searchForm.email,name:this.searchForm.name,phone:this.searchForm.phone})
				.then((response)=>
				{
					this.currentPage=response.data.data.current;
					this.pageSize=response.data.data.size;
					this.list=response.data.data.records;
					this.total=response.data.data.total;
				})
			},
			// 当前条数   
			handleSizeChange(val) 
			{
				this.page=1;
				this.pageSize=val;
				this.getList()
			},
			// 当前页数
			handleCurrentChange(val) 
			{
				this.page=val;
				this.getList()
			},
			// 搜索按钮
			search()
			{
				leaveList(
				{
					page:1,
					pageSize:10,
					name:this.searchForm.name,
					phone:this.searchForm.phone,
					mail:this.searchForm.email
				})
				.then((response)=>
				{
					this.currentPage=response.data.data.current;
					this.page=response.data.data.pages;
					this.pageSize=response.data.data.size;
					this.total=response.data.data.total;
					// 判断留言是单条数据还是多条
					if(response.data.data.records.length>1)
					{
						this.issearch=false;
						this.list=response.data.data.records;
					}
					else if(response.data.data.records.length==1)
					{
						console.log(1)
						this.issearch=true;
						this.searchList=response.data.data.records[0];
					}
					else
					{
						this.open()
						this.reset()
					}
				})
			},
			// 重置
			reset()
			{
				this.searchForm=[]
				this.issearch=false;
				// this.page=1;
				// this.pageSize=10;
				this.currentPage=1;
				this.handleCurrentChange(1);
			},
			// 没有数据
			open() 
			{
				this.$alert('请查看是否输入正确', '没有找到相关数据', 
				{
					confirmButtonText: '确定',
				});
			}
		}
	}
</script>

<style scoped>
	@import '../assets/table.css';
	.crumbs{
		width: 100%;
		padding: 10px 0px 10px;
	}
	.selectbox{
		 margin-top: 10px;
		 margin-bottom: 20px;
	}
	.title{
		line-height: 30px;
	}
	.select{
		width: 90%;
		height: 30px;
	}
	.formbox{
		background-color: #F2F2F2;
		padding-left: 10px;
		margin-top: 10px;
	}
	.tablebox{
		width: 98%;
		background-color: #E4E4E4;
	}
	.table-trtitle{
		height: 50px;
		background-color: white;
		margin-top: 10px;
	}
	.tooltipitem{
		display: block;
		max-width: 500px !important;
	}
</style>